// extracted by css-extract-rspack-plugin
export default {"mainInfoWrapper":"main-info-wrapper--fz0MDjHKbcsT9l5A"};